module.exports = __webpack_public_path__ + "static/media/video.72440054.svg";